var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"hidden-sm-and-down",attrs:{"size":"14"},domProps:{"textContent":_vm._s('$mdiChevronDown')}})}
var staticRenderFns = []

export { render, staticRenderFns }